import { ComponentType, lazy, LazyExoticComponent } from 'react'
import { isChunkLoadError } from './chunk-load-error'

const DEFAULT_RETRIES = 2
const RETRY_DELAY_MS = 800

const wait = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

export function lazyWithRetry<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
  retries = DEFAULT_RETRIES,
): LazyExoticComponent<T> {
  return lazy(async () => {
    let lastError: unknown

    for (let attempt = 0; attempt <= retries; attempt += 1) {
      try {
        return await factory()
      } catch (error) {
        lastError = error

        if (!isChunkLoadError(error)) {
          throw error
        }

        if (attempt < retries) {
          await wait(RETRY_DELAY_MS * (attempt + 1))
          continue
        }

        throw error
      }
    }

    throw lastError
  })
}
